import { useState, useEffect } from "react";

function CollapsibleSection({ id, name, defaultCollapsed, expandedOnDesktop, card, children }) {

  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  const [isCard, setIsCard] = useState(card);

  useEffect(() => {
    // for sections that are collapsed by default,
    // but should be expanded by default above 1200px
    if (expandedOnDesktop && window.innerWidth >= 1200) {
      setIsCollapsed(false);
    }

    // special case for <Notes>, which is a card on mobile but not on desktop
    if (id === 'notes' && window.innerWidth >= 1200) {
      setIsCard(false);
    }
  }, [])

  return (
    <section 
      className={`collapsible ${isCard ? "card" : ""}`} 
      data-collapsed={isCollapsed}
      id={id}
    >
      <h2 onClick={() => setIsCollapsed(!isCollapsed)} className="section-header">{name}</h2>
      {children}
    </section>
  )
}

export default CollapsibleSection;